var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"antd-slider-custom flex items-center gap-2"},[_c('div',{staticClass:"w-full"},[_c('Slider',{attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value},on:{"change":_vm.change}})],1),_c('div',{staticClass:"w-24 h-full"},[_c('Input',{attrs:{"prefix":_vm.prefix,"suffix":_vm.suffix,"value":_vm.value},on:{"change":_vm.onChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }